export const AccommodationSections = {
	Pictures: 'pictures',
	Overview: 'overview',
	Reviews: 'reviews',
	SimilarAccos: 'similar-accos',
	Information: 'information',
	Availability: 'availability',
	AvailabilityOffers: 'availability-offers',
	Facilities: 'facilities',
} as const;

export type AccommodationSectionType = (typeof AccommodationSections)[keyof typeof AccommodationSections];

export const MENU_SCROLL_DURATION = 500;
export const MENU_OFFSET = -72;
